module.exports = __webpack_public_path__ + "img/check.7abf4547.svg";